import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_md,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const nextPayment = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: ${spacing(4)};
  flex-wrap: wrap;
  padding-bottom: ${spacing(4)};
  border-bottom: 1px solid ${base_colorContentBorder};
`

/*
 * No `margin: 0` on this or `nextPaymentFigure`, despite both being <p>: the
 * app-wide `* { margin: 0; padding: 0 }` reset in src/style/baseGlobalStyles.tsx
 * (mounted at the client root) already zeroes UA paragraph margins, so
 * restating it here would be dead weight — and stating it on one <p> and not
 * its sibling is what makes the pair look inconsistent.
 */
export const nextPaymentLabel = css`
  font-size: ${font_size_sm};
  line-height: 18px;
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const nextPaymentFigure = css`
  display: flex;
  align-items: baseline;
  gap: ${spacing(2.5)};
  margin-top: ${spacing(1)};
`

/**
 * The design pins this hero figure at 28px/42px, measured off the SHA-pinned
 * prototype. There is no 28px typography token — `font_size_3xl` is 24px and
 * `font_size_4xl` is 32px, and on a figure this prominent either is visibly
 * wrong. Written out rather than rounded to a token, which is the same kind of
 * documented DS gap the design bundle already records for its compact Button.
 */
export const nextPaymentAmount = css`
  font-size: 28px;
  line-height: 42px;
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
  /* Figures share a column width so the decimal points line up. */
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
`

export const nextPaymentDue = css`
  font-size: ${font_size_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const historyHeading = css`
  font-size: ${font_size_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
  margin: ${spacing(4)} 0 ${spacing(1)};
`

export const historyList = css`
  list-style: none;
`

export const historyRow = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(4)};
  padding: ${spacing(3)} 0;
  border-bottom: 1px solid ${base_colorContentBorder};

  &:last-of-type {
    border-bottom: none;
  }
`

export const historyAmount = css`
  font-size: ${font_size_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
  font-variant-numeric: tabular-nums;
`

export const historyDetail = css`
  font-size: ${font_size_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  margin-top: ${spacing(0.5)};
`
